import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, EventEmitter,
  Input,
  OnChanges, Output,
  SimpleChanges,
} from '@angular/core';
import { Shipment } from '@shared-features/models/shipment';
import { ShipmentCreationTemplateTypes } from "@shared/enums/shipment-creation-template-types.enum";
import { LocationType } from "@shared/enums/location-type.enum";
import { ShipmentStatus } from "@shared-features/enums/shipment-status.enum";
import { ShipmentsApiService } from '@features/shipments/services/shipments-api.service';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { User } from '@features/users/models/user';
import { Customer } from '@features/customers/models/customer';
import { Receiver } from '@features/receivers/models/receiver';
import { LocationModel } from '@features/live-tracking/models/location.model';
import { LocalStorageUtil } from '@shared/utils/local-storage.util';
import { StorageConstant } from '@shared/constants';

@Component({
  selector: 'app-shipping-card',
  templateUrl: './shipping-card.component.html',
  styleUrls: ['./shipping-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShippingCardComponent extends BaseComponent implements OnChanges {
  @Input() shipment: Shipment;
  @Output() editLocation = new EventEmitter<{
    locationType: LocationType,
    locationOwner: Customer | Receiver,
    location: LocationModel
  }>();

  @Output() updated = new EventEmitter();
  isMaskData= LocalStorageUtil.getItem(StorageConstant.MASK_DATA);

  get pickUpContact(): User {
    return this.getUserLocation(this.shipment?.pickUpLocation);
  }

  get dropOffContact(): { firstName?: string, lastName?: string, mobileNumber?: string } {
    const { dropOffUser, contactPerson , dropOffLocation } = this.shipment || {};
    return dropOffUser || contactPerson || this.getUserLocation(dropOffLocation);
  }

  readonly LocationType = LocationType;

  constructor(
    private shipmentsApiService: ShipmentsApiService,
    private changeRef: ChangeDetectorRef,

  ) {
    super();
  }

  ngOnChanges({ shipment }: SimpleChanges): void {
    if (shipment && shipment.currentValue !== shipment.previousValue) {
      this.changeRef.markForCheck();
    }
  }

  openEditLocationModal(locationType: LocationType): void {
    this.editLocation.emit({
      locationType,
      locationOwner:  locationType === LocationType.Customer ? this.shipment?.customer : this.shipment?.receiver,
      location: locationType === LocationType.Customer ? this.shipment?.pickUpLocation : this.shipment?.dropOffLocation,
    });
  }


  resendDriverOtp(): void{
    this.load(this.shipmentsApiService.resendOTP(this.shipment?.id), {
      isLoadingTransparent: true,
    }).subscribe(
      () => this.updated.emit(),
      () => this.updated.emit()
    );
  }

  private getUserLocation(location: LocationModel): User {
    const usersLocations = location?.usersLocations || [];
    const defaultUserLocation = usersLocations.find((user) => user.isDefault);
    const userLocation = usersLocations[0];
    return (defaultUserLocation || userLocation)?.user;
  }

  protected readonly ShipmentCreationTemplateTypes = ShipmentCreationTemplateTypes;
  protected readonly ShipmentStatus = ShipmentStatus;
}
